import { z } from 'zod';

import { alertSchema } from '../schema/Alert.ts';
import { validateData } from '../utils/utils.ts';
import { api } from './client.ts';
import { getAlertsUrl, patchAlertsUrl } from './constants.ts';

export async function getAlerts(
  territorySlug: string,
  queryParameters: Record<string, string>,
  signal?: AbortSignal,
) {
  const { data } = await api.get(getAlertsUrl(territorySlug, queryParameters), { signal });
  return validateData(z.array(alertSchema), data['results'], 'Alert');
}

export async function patchAlert(territorySlug: string, alertId: number, data: { lifecycle: string }) {
  return await api.patch(patchAlertsUrl(territorySlug, alertId), data);
}
